import { render, staticRenderFns } from "./client-product-inquiry.vue?vue&type=template&id=3752cfff&scoped=true&"
import script from "./client-product-inquiry.vue?vue&type=script&lang=js&"
export * from "./client-product-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752cfff",
  null
  
)

export default component.exports